import { t } from "../strings";

// The site's name with its mark (owner's choice, 2026-10-12; the traditional 話 since 2026-11-03): 話, "speech", on a tile; public/icon-*.png, drawn
// by scripts/logo.py.
export function Brand(props: { size?: number }) {
  return (
    <span class="brand">
      <img src="/icon-192.png" alt="" width={props.size ?? 40} height={props.size ?? 40} />
      {t.appName}
    </span>
  );
}
